import { tv } from "tailwind-variants";

export const useTransitionDuration = tv({
  variants: {
    transitionDuration: {
      default: "duration-300",
    },
  },
});
